import Big, { BigSource } from "big.js"

import { Discount } from "../types/Discount"
import { bigEquals } from "./Big"
import { formatNumberToTwoDecimals } from "./Locale"
import { formatMoney } from "./Money"

export function discountEquals(a: Discount, b: Discount) {
  return (
    a.name == b.name &&
    bigEquals(a.percent, b.percent) &&
    bigEquals(a.absolute, b.absolute)
  )
}

export function formatDiscount(
  discount: Discount,
  opts?: { omitMinusSign?: boolean },
) {
  const minusSign = opts?.omitMinusSign || discount?.percent?.eq(0) ? "" : "-"

  const absolute = opts?.omitMinusSign
    ? discount.absolute
    : discount.absolute?.times(-1)

  let formattedDiscount = absolute
    ? formatMoney(absolute)
    : discount.percent
    ? `${minusSign}${formatNumberToTwoDecimals(discount.percent.toNumber())}%`
    : ""

  if (formattedDiscount.includes("--"))
    formattedDiscount = formattedDiscount.replace("-", "")

  return formattedDiscount
}

export function isPercentDiscountValid(percent?: BigSource) {
  if (percent == undefined) return false
  const bigPercent = Big(percent)
  return bigPercent.gte(0) && bigPercent.lte(100)
}
